import { lazyComponent } from '../../lib/lazy'
import type { WebModule } from '../../lib/modules'

export const module: WebModule = {
  routes: [],
  entityOverrides: {
    event: {
      ListPage: lazyComponent(() => import('./EventsPage'), 'EventsPage'),
    },
  },
}
